module.exports = __webpack_public_path__ + "img/card_about.541a305a.png";